import type {
  Outlet,
  OutletSummary,
} from "@/app/services/generated/outletService";
import { OutletService } from "@/app/services/generated/outletService";
import type { Group } from "@/app/services/generated/groupService";
import type { Maybe } from "@/components/utils/typeHelpers";
import type { MapMarker } from "@/components/controls/map/maps";

export default class OutletServiceExtended extends OutletService {
  public getProductRequirementsFromOutletAndGroup(
    outlet: Maybe<Readonly<Outlet | OutletSummary>>,
    group: Maybe<Readonly<Group>>
  ): string {
    return group?.useGroupProductRequirementsForAllOutlets
      ? group.productRequirements
      : (outlet?.productRequirements ?? "");
  }

  public outletSummaryToMapMarker<Meta>(
    outlet: Readonly<OutletSummary>,
    opts?: Partial<MapMarker<Meta>>
  ): MapMarker<Meta> {
    const defaultOptions: MapMarker<Meta> = {
      key: outlet.id.toString(),
      name: [outlet.displayName, outlet.code].join(" | "),
      lat: outlet.mainLatitude,
      lng: outlet.mainLongitude,
    };

    return { ...defaultOptions, ...opts };
  }
}

export const outletService = new OutletServiceExtended();
